import { render, staticRenderFns } from "./fccConfiguracaoDefinidaParaPublicacao.vue?vue&type=template&id=7407572f"
import script from "./fccConfiguracaoDefinidaParaPublicacao.vue?vue&type=script&lang=js"
export * from "./fccConfiguracaoDefinidaParaPublicacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports